import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Logo from '../../assets/tete-leo.png';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#dbf0f7',
    minHeight: 100,
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(5) + 100,
    borderRadius: 10,

    position: 'relative',
  },
  image: {
    width: 100,
    height: 100,
    position: 'absolute',
    top: -theme.spacing(4),
    left: 0,
  },
  text: {
    color: 'black',
  },
}));

type InfoProps = {
  title: string | React.ReactNode;
  subtitle: string | React.ReactNode;
};

export const Info = ({ title, subtitle }: InfoProps) => {
  const classes = useStyles();

  return (
    <Paper className={classes.container} elevation={0}>
      <img src={Logo} className={classes.image} alt="logo" />
      <Typography className={classes.text}>
        <strong>{title}</strong>
      </Typography>
      <Typography className={classes.text}>{subtitle}</Typography>
    </Paper>
  );
};

export default Info;
